import React, { useMemo } from "react";

import { useForm } from "react-hook-form";
import moment from "moment";

import { EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import AbstractSelect from "../AbstractFormField/fields/AbstractSelect";
import ProfileTabName from "./ProfileTabName";

import { monthSelectOptions } from "./constants";

function ProfileStatsHeader({ statsMonth, onStatsMonthChange, isLoading }) {
    const { register, errors } = useForm();

    const monthName = useMemo(() => moment.months(+statsMonth), [statsMonth]);

    return (
        <EuiFlexGroup
            justifyContent="spaceBetween"
            gutterSize="m"
            alignItems="center"
        >
            <EuiFlexItem grow={false}>
                <ProfileTabName
                    label={`${monthName} Report`}
                    size="m"
                    hideIcon
                />
            </EuiFlexItem>

            <EuiFlexItem grow={false}>
                <AbstractSelect
                    options={monthSelectOptions}
                    errors={errors}
                    entityObject={{ [monthSelectOptions.name]: statsMonth }}
                    register={register}
                    onChange={(name, value) => onStatsMonthChange(name, value)}
                    isLoading={isLoading}
                />
            </EuiFlexItem>
        </EuiFlexGroup>
    );
}

export default ProfileStatsHeader;
